import * as axios from 'axios'
import store from '@/store'

const getPublicApiToken = async function () {
  try {
    const response = await axios.get(
      process.env.VUE_APP_DRIP_API_HOST + '/v1/access/token'
    )
    return response.data.token
  } catch (error) {
    return null
  }
}

const apiHsnQuery = async function (searchQuery, count, page, isKeywordPage) {
  const urlKeyword = isKeywordPage ? 'list?search' : 'search'
  const query = isKeywordPage ? searchQuery.toUpperCase() : searchQuery
  try {
    const token = store.state.apiPublicToken
      ? store.state.apiPublicToken
      : await this.getPublicApiToken()
    const response = await axios({
      url:
        process.env.VUE_APP_DRIP_API_HOST + `/v1/labs/hsn-code/${urlKeyword}`,
      params: {
        search: query,
        count: count,
        page: page
      },
      headers: {
        Authorization: 'Token ' + token
      }
    })
    return isKeywordPage ? response.data.results : response.data.result
  } catch (error) {
    return {}
  }
}

const apiHtsQuery = async function (searchQuery) {
  const isKeywordPage = true
  try {
    const token = store.state.apiPublicToken
      ? store.state.apiPublicToken
      : await this.getPublicApiToken()
    const response = await axios({
      url: process.env.VUE_APP_DRIP_API_HTS_HOST + `/api/search`,
      params: {
        search_query: searchQuery
      },
      headers: {
        Authorization: 'Token ' + token
      }
    })
    return isKeywordPage ? response.data : response.data.result
  } catch (error) {
    return {}
  }
}

const defaulFlexibleApi = async function (searchPathQuery) {
  try {
    const res = await axios.get(
      process.env.VUE_APP_DRIP_API_HTS_HOST + `/api/${searchPathQuery}`
    )

    return res.data
  } catch (e) {
    return null
  }
}

export default {
  getPublicApiToken,
  apiHsnQuery,
  apiHtsQuery,
  defaulFlexibleApi
}
